import { INotificationProps } from "providers";
import dayjs from "./dayjsSetup";
import { ApiResponse } from "./types";
import { LOCAL_STORAGES } from "./constants";


export const handleRequest = async <T,O>(requestFn: (input: T) => Promise<ApiResponse<O>>, input: T, notification?: INotificationProps): Promise<O|undefined> => {
  const { data, success, err } = await requestFn(input);
  if (!success) {
    console.info({ Name: requestFn.name, err })
    notification?.error({
        message: err?.message || "An error occurred",
    });
    return undefined;
  }
  return data ?? undefined
};
export function copyToClipboard(text: string): Promise<void> {
  return navigator.clipboard.writeText(text);
}

export const uploadImages = async <T>(data: {
  file: File|undefined, 
  name: string, 
  schemaName: string; 
  schemaId: string
}[]) : Promise<(T|undefined)[]> => {
  const actions = []
  for (let i = 0; i < data.length; i++) {
    const value = data[i];
    if(!value.file){
      actions.push(Promise.resolve(undefined))
      continue
    }
    const formData = new FormData();
    formData.append("name", value.name);
    formData.append("file", value.file);
    formData.append("schemaName", value.schemaName);
    formData.append("schemaId", value.schemaId);
    actions.push(uploadFile<T>(formData));
  }
  return Promise.all(actions);
}
export const uploadFile = async <T>(formData: FormData):Promise<T|undefined> => {
  if(formData.get("file") === null){
    return
  }
  try{
    const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/api/upload", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${localStorage.getItem(LOCAL_STORAGES.ACCESS_TOKEN)}`
      },
      body: formData,
    });
  
    const data = await response.json();
    console.log("Upload success", data);
    return data as T;
  }catch(e){
    console.error({ e })
  }
}
export const dateFromNow = (isoDate: string) => {
  return dayjs(isoDate).fromNow()
};
export function getRandomNumberInRange(min: number, max: number): number {
    if (min > max) {
      throw new Error("Min value cannot be greater than max value.");
    }
    return Math.random() * (max - min) + min;
  }

export const balanceShort = (bal: number) => {
  const k = Math.round(bal / 10**3); 
  const m = Math.round(bal / 10**6);
  const b = Math.round(bal / 10**9);
  if(bal >= 10**3 && k < 10**3){
    return k + "k";
  }
  if(bal >= 10**6 && m < 10**3){
    return m + "m";
  }
  if(bal >= 10**9 && b < 10**3){
    return b + "b";
  }
  return Math.round(bal)
}
export function dateCountdownFormat(isoDateString: string): { isExpired: boolean; countDown: string } {
  const now = new Date();
  const targetDate = new Date(isoDateString);

  const diffMs = targetDate.getTime() - now.getTime();

  const isExpired = diffMs <= 0;

  const diffDays = Math.max(Math.floor(diffMs / (1000 * 60 * 60 * 24)), 0);
  const diffHours = Math.max(Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), 0);
  const diffMinutes = Math.max(Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60)), 0);

  const countDown = `${diffDays}d:${diffHours}h:${diffMinutes}m`;

  return { isExpired, countDown };
}
export const isEmptyString = (value?: string) => {
  return Boolean(value)
}
export const wait = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve("");
    }, ms);
  });
};
export const isEmail = (data: string) => {
  return data.includes("@") && data.includes(".");
};
export const isPhone = (data: string) => {
  return data.length >= 10;
}
export const isPassword = (data: string) => {
  return data.length >= 8
}
export const validateEmail = (email: string):boolean => {
  const match = String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  return Boolean(match)
}
export const validatePhone = (phone: string):boolean => {
  const match = String(phone)
    .toLowerCase()
    .match(
      /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
      // /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
    )
  return Boolean(match)
}
export const validatePassword = (password: string):boolean => {
  const match = String(password)
    .toLowerCase()
    .match(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/
    )
  return Boolean(match)
}
export function gqlQueryStringBuilder<Q extends object, T = undefined>(
  query?: (keyof Q)[] | (keyof T)[],
  nestedValues?: T
) {
  let queryString = "";
  if (query)
    for (let i = 0; i < query.length; i++) {
      const element = query?.[i];
      if (nestedValues?.[element as keyof T]) {
        queryString += `${String(element)} { 
          ${gqlQueryStringBuilder(nestedValues[element as keyof T] as (keyof T)[], nestedValues)} 
        }`;
      } else queryString += `${String(element)} `;
    }
  return queryString;
}
